import { useEffect, useMemo, useState } from 'react'
import { db, type Expense } from '../lib/db'
import { deleteExpense } from '../lib/sync'
import ExpenseCard from './details/ExpenseCard'
import FilterBar, { type Filter } from './details/FilterBar'
import EditModal from './details/EditModal'

const EMPTY_FILTER: Filter = { category: '', keyword: '', dateFrom: '', dateTo: '' }

export default function DetailsPage() {
  const [expenses, setExpenses] = useState<Expense[]>([])
  const [filter, setFilter] = useState<Filter>(EMPTY_FILTER)
  const [editTarget, setEditTarget] = useState<Expense | null>(null)

  useEffect(() => {
    db.expenses
      .filter(e => e.deleted_at === null)
      .reverse()
      .sortBy('date')
      .then(arr => setExpenses(arr.reverse()))
  }, [])

  const filtered = useMemo(() => {
    return expenses.filter(e => {
      if (filter.category && e.category !== filter.category) return false
      if (filter.dateFrom && e.date < filter.dateFrom) return false
      if (filter.dateTo   && e.date > filter.dateTo)   return false
      if (filter.keyword) {
        const kw = filter.keyword.toLowerCase()
        const haystack = `${e.description ?? ''} ${e.note ?? ''}`.toLowerCase()
        if (!haystack.includes(kw)) return false
      }
      return true
    })
  }, [expenses, filter])

  async function handleDelete(id: string) {
    if (!confirm('確定刪除這筆紀錄？')) return
    await deleteExpense(id)
    setExpenses(prev => prev.filter(e => e.id !== id))
  }

  function handleSaved(updated: Expense) {
    setExpenses(prev => prev.map(e => e.id === updated.id ? updated : e))
  }

  return (
    <div className="details-page">
      <header className="page-header">
        <div className="page-header-left">
          <h1 className="page-header-title">明細</h1>
          <p className="page-header-sub">共 {filtered.length} 筆</p>
        </div>
      </header>
      <FilterBar filter={filter} onChange={setFilter} />
      {filtered.length === 0 && (
        <p className="placeholder">沒有符合的紀錄</p>
      )}
      <div className="card-list">
        {filtered.map(e => (
          <ExpenseCard
            key={e.id}
            expense={e}
            onEdit={setEditTarget}
            onDelete={handleDelete}
          />
        ))}
      </div>

      {editTarget && (
        <EditModal
          expense={editTarget}
          onClose={() => setEditTarget(null)}
          onSaved={handleSaved}
        />
      )}
    </div>
  )
}
